import * as player from '../player.js';
import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';
import { Tween } from '../tweens.js'

export {
    init,
}

let pedaloSound;

const POIs = [
    {
        name: 'pedalo',
        position: { x: 8, y: -27, z: 0 },
        color: 'blue',
        radius: 5,
        sound: {
            name: 'pedalo-idle',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
        collision: {
            radius: 1,
        },
        async onEnter() {
            // Follow player
            pedaloSound = await audio.buffers.play('pedalo', {
                loop: true,
                gain: 0,
            });
            const originalPosition = { ...this.position };
            new Tween(this.position, player.position, 1, 'easeOutQuad', (v) => {
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween) => {
                setTimeout(() => {
                    // Manual cleanup to stop following player
                    tween.dispose();
                    pedaloSound.fade();
                    new Tween(this.position, originalPosition, 4, 'easeInOutQuad', (v) => {
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new Tween(12, 5, 2, 'easeOutQuad', (v) => {
                        this.radius = v;
                    });
                }, 10000);
            });
            // Increase radius to 15
            new Tween(this.radius, 12, 0.5, 'easeOutQuad', (v) => {
                this.radius = v;
            });
        },
    },
];

const sounds = [
    { name: 'pedalo-idle', url: new URL('../../sound/Pedalo_pause.wav', import.meta.url) },
    { name: 'pedalo', url: new URL('../../sound/Pedalo.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
